import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'invoicePaymentType'
})
export class InvoicePaymentTypePipe implements PipeTransform {

  transform(value: boolean, args?: any): any {
    return value ? 'Pago Parcial' : 'Pago Total';
  }

}
